import { useState } from "react";

type LinkProps = {
  text: string;
  url: string;
};

function Link({ text, url }: LinkProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [hasOpenedExternal, setHasOpenedExternal] = useState(false);

  const handleOpenModal = (e: React.MouseEvent) => {
    e.preventDefault();
    window.umami?.track("link_modal_opened", { url });
    setHasOpenedExternal(false);
    setIsOpen(true);
  };

  const handleOpenExternal = () => {
    window.umami?.track("link_external_opened", { url });
    setHasOpenedExternal(true);
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleClose = () => {
    window.umami?.track("link_modal_closed", {
      url,
      opened_external: hasOpenedExternal,
    });
    setIsOpen(false);
  };

  return (
    <>
      <p>
        {text}
        <a href={url} onClick={handleOpenModal}>
          {url}
        </a>
      </p>
      {isOpen ? (
        <div
          className="link-iframe-modal"
          role="dialog"
          aria-modal="true"
          aria-label="Document externe"
        >
          <div className="link-iframe-header">
            <span className="link-iframe-title">Document externe</span>
            <button
              type="button"
              className="link-iframe-close"
              onClick={handleClose}
              aria-label="Fermer"
            >
              <span aria-hidden="true">×</span> Fermer
            </button>
          </div>

          <div className="link-iframe-body">
            {!hasOpenedExternal ? (
              <>
                <p className="link-iframe-text">
                  Le document va s'ouvrir dans un nouvel onglet afin de
                  préserver votre saisie. Vous pourrez revenir à ce formulaire
                  à tout moment.
                </p>
                <p className="link-iframe-url">{url}</p>
                <button
                  type="button"
                  className="link-iframe-action"
                  onClick={handleOpenExternal}
                >
                  Ouvrir le document
                </button>
              </>
            ) : (
              <>
                <p className="link-iframe-text">
                  Le document a été ouvert dans un nouvel onglet. Consultez-le
                  puis revenez sur cet onglet pour continuer votre formulaire.
                </p>
                <button
                  type="button"
                  className="link-iframe-action"
                  onClick={handleClose}
                >
                  J'ai terminé, revenir au formulaire
                </button>
                <button
                  type="button"
                  className="link-iframe-action link-iframe-action-secondary"
                  onClick={handleOpenExternal}
                >
                  Rouvrir le document
                </button>
              </>
            )}
          </div>
        </div>
      ) : null}
    </>
  );
}

export default Link;
